export function createActionType(actionTypeName, prefix) {
    return prefix+"_"+actionTypeName;
}

export function createActionTypes(actionTypes, prefix) {
    const actionTypesWithPrefix = {};
    Object.getOwnPropertyNames(actionTypes).forEach(actionType=>{
        actionTypesWithPrefix[actionType] = createActionType(actionType,prefix);
    });
    return actionTypesWithPrefix;
}

export function createInitialStatePart(name, initialData = {}) {
return {
    [`${name}Loading`]: false,
    [`${name}Loaded`]: false,
    [name]: initialData,
    [`${name}Error`]: null,
};
}

export function setReducerState(status, name, payload) {
    const { state, data, error } = payload;
    switch (status) {
        case 'loading':
        return {
            ...state,
            [`${name}Loading`]: true
        };
        case 'loaded':
        return {
            ...state,
            [`${name}Loading`]: false,
            [`${name}Loaded`]: true,
            [name]: data,
            [`${name}Error`]: null
        };
        case 'error':
        return {
            ...state,
            [`${name}Loading`]: false,
            [`${name}Loaded`]: false,
            [name]: data || state[name], // clear data if passed or leave previous
            [`${name}Error`]: error
        };
        default:
        return state;
    }
}
